import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import PropTypes from 'prop-types';
import { Container, CouponHeader, CouponContent, DashedLine, SideCut } from './coupon-card.styles';

const CouponCard = _ref => {
  let {
    headerText,
    children
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["headerText", "children"]);

  return /*#__PURE__*/React.createElement(Container, _extends({
    "data-testid": "coupon-card"
  }, props), /*#__PURE__*/React.createElement(SideCut, null), headerText && /*#__PURE__*/React.createElement(CouponHeader, {
    "data-testid": "coupon-header"
  }, headerText), /*#__PURE__*/React.createElement(DashedLine, {
    "data-testid": "coupon-dashed-line"
  }), /*#__PURE__*/React.createElement(CouponContent, {
    "data-testid": "coupon-content"
  }, children));
};

process.env.NODE_ENV !== "production" ? CouponCard.propTypes = {
  headerText: PropTypes.string,
  children: PropTypes.node.isRequired
} : void 0;
CouponCard.defaultProps = {
  headerText: ''
};
export default CouponCard;